import React, {useMemo} from 'react';
import {Popover} from 'antd';
import type {PopoverProps} from 'antd';
import {TooltipPlacement} from "antd/es/tooltip";


interface IPopOverProps {
    title?: string;
    arrow: 'Show' | 'Hide' | 'Center';
    content: React.ReactNode;
    trigger?: 'hover' | 'click';
    placement?:  TooltipPlacement;
    children?: React.ReactNode;
    theme?: 'light' | 'dark'
    open ?: boolean;
    onOpenChange?: (open: boolean) => void;
}

const PopoverComponent: React.FC<IPopOverProps> = ({arrow, title, content, trigger, placement, children, theme, open, onOpenChange}) => {

    const mergedArrow = useMemo<PopoverProps['arrow']>(() => {
        if (arrow === 'Hide') {
            return false;
        }

        if (arrow === 'Show') {
            return true;
        }

        return {
            pointAtCenter: true,
        };
    }, [arrow]);

    return (
        <Popover open={open} onOpenChange={onOpenChange} color={theme === 'dark' ? 'rgb(46 59 77)': 'white'} placement={placement ?? 'right'} trigger={trigger} title={title} content={content} arrow={mergedArrow}>
            {children}
        </Popover>
    );
};

export default PopoverComponent;
